import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import { ProgramReport, useProgramReport } from "./reportUtils";
import { LoadingButton } from "@mui/lab";
import { useTranslation } from "react-i18next";
import { ReportLoadingOverlay } from "./FrontendUserReport";

interface FrontendProgramReportProps {
  institutionId?: string;
  columns: GridColDef<ProgramReport>[];
}

export const FrontendProgramReport = ({
  institutionId,
  columns
}: FrontendProgramReportProps) => {
  const { t } = useTranslation();
  const {
    status: fetchReportStatus,
    error: fetchReportError,
    report,
    generateProgramReport
  } = useProgramReport();

  return (
    <>
      <div>
        <LoadingButton
          variant="contained"
          disabled={!institutionId}
          loading={fetchReportStatus === "loading"}
          onClick={() => {
            if (institutionId) {
              generateProgramReport(institutionId);
            }
          }}
        >
          {t("Generate Report")}
        </LoadingButton>
      </div>
      <DataGrid
        aria-label="reports-table"
        rows={report}
        columns={columns}
        loading={fetchReportStatus === "loading"}
        slots={{
          loadingOverlay: ReportLoadingOverlay,
          toolbar: GridToolbar
        }}
      />
    </>
  );
};
